export const saveToLocalStorage = store => next => action => {
    let result = next(action);
    if (action.type.includes('basket/')) {
        localStorage.setItem('basketItems', JSON.stringify(store.getState().basket.items));
    }
    return result;
};
